import { DEFAULT_TOTAL_RECORDS } from "utils/constants";

const { EndPoints } = require("settings/endpoints");
const { default: axiosInstance } = require("./axios");
const zone_id = Number(localStorage.getItem("zone_id"));

export const fetchAttendance = (page_no, filter, limit = DEFAULT_TOTAL_RECORDS) => {
  return axiosInstance.get(EndPoints.ATTENDANCE.LIST, {
    params: {
      limit,
      page_no,
      zone_id,
      ...filter
      // total_count:totalItems
    }
  });
}

export const createEmployeeMarkLogIn = (payload) => {
  return axiosInstance.post(EndPoints.EMPLOYEE_ACTIVITY.CREATE_MARK_LOGIN, payload)
}
export const createEmployeeMarkLogOut = (payload) => {
  return axiosInstance.post(EndPoints.EMPLOYEE_ACTIVITY.CREATE_MARK_LOGOUT, payload)
}
